/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_AccountInputs */

const cs_settings_profile_account = /** @type {(inputs: Settings_Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet`)
};

const en_settings_profile_account = /** @type {(inputs: Settings_Profile_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Settings_Profile_AccountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_account = /** @type {((inputs?: Settings_Profile_AccountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_AccountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_account(inputs)
	return cs_settings_profile_account(inputs)
});